import { fetchProfileList } from '../../onboarding/services/onboardingService';
import { normalizeProfileList } from '../utils/normalizeLicense';
import { computeHasMore } from '../../../components/ui/SearchableSelect/selectUtils';

export function mapProfileToSelectOption(profile = {}) {
  const [normalized] = normalizeProfileList([profile]);
  if (!normalized) return null;

  return {
    ...normalized,
    label: normalized.organisationName
      ? `${normalized.name} (${normalized.organisationName})`
      : normalized.name,
  };
}

export async function fetchProfileListPage({ page, pageSize, search = '', extraParams = {}, signal }) {
  const res = await fetchProfileList({
    page,
    limit: pageSize,
    search,
    organisation_id: extraParams.organisation_id,
    signal,
  });

  if (!res.ok) {
    throw new Error('Failed to load permission profiles');
  }

  const rawList = Array.isArray(res.data?.list)
    ? res.data.list
    : Array.isArray(res.data?.results)
      ? res.data.results
      : Array.isArray(res.data)
        ? res.data
        : [];
  const items = rawList.map(mapProfileToSelectOption).filter(Boolean);
  const totalCount = res.data?.count ?? null;

  return {
    items,
    totalCount,
    hasMore: computeHasMore({
      page,
      pageSize,
      itemsLength: items.length,
      totalCount,
    }),
  };
}
